import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import Dialog from '@/components/common/dialog';
import PermissionForm from './components/task-form';
import { getList as _getList, deleteItems as _deleteItems } from '@/api/setting/task';
export default {
  name: 'setting-task',
  data: function data() {
    return {
      template: null,
      currentTableData: [],
      loading: false,
      pageSize: 10,
      currentPage: 1,
      total: 0,
      items: [],
      searchKey: ''
    };
  },
  methods: {
    getRole: function getRole(list, type) {
      if (Array.isArray(list) && list.length) {
        var roles = list.filter(function (item) {
          return item.n21Role1 === type;
        });
        var res = roles.map(function (item) {
          return "<span>".concat(item.n21StaffName, "</span>");
        });
        return res.join();
      }
      return '';
    },
    deleteItems: function deleteItems(item) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var ids;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _this.$$confirm('确定删除?');
            case 1:
              ids = _this.items.map(function (id) {
                return id.info.n02Id;
              });
              _context.n = 2;
              return _deleteItems(JSON.stringify(ids.join(',')));
            case 2:
              _this.$message.success('操作成功');
              _this.items = [];
              _this.$refs.table.clearSelection();
              _this.getList();
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    handleSelectionChange: function handleSelectionChange(items) {
      this.items = items;
    },
    handleCurrentChange: function handleCurrentChange(page) {
      if (this.loading) {
        return;
      }
      this.currentPage = page;
      this.getList();
    },
    create: function create(item) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _yield$_this2$$awaitT, _yield$_this2$$awaitT2, err;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$awaitTo(Dialog(PermissionForm, {
                dialog: {
                  title: item ? '编辑' : '新增',
                  width: '750px'
                },
                props: {
                  id: item ? item.info.n02Id : undefined,
                  onlyReady: !_this2.isAuth
                }
              }, function (template) {
                _this2.template = template;
              }));
            case 1:
              _yield$_this2$$awaitT = _context2.v;
              _yield$_this2$$awaitT2 = _slicedToArray(_yield$_this2$$awaitT, 1);
              err = _yield$_this2$$awaitT2[0];
              _this2.template = null;
              if (!err) {
                _this2.getList();
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getList: function getList() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _yield$_getList, data, datas, total, identityType;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this3.loading = true;
              _context3.n = 1;
              return _getList({
                simpleSearch: _this3.searchKey,
                length: _this3.pageSize,
                page: _this3.currentPage
              });
            case 1:
              _yield$_getList = _context3.v;
              data = _yield$_getList.data;
              datas = data.datas, total = data.total;
              identityType = {
                '合伙人': 'partners',
                '经理': 'managers',
                '现场负责人': 'leaders',
                '独立质控人': 'IQC',
                '独立质控合伙人': 'IQCP'
              };
              _this3.currentTableData = datas;
              _this3.total = total;
              _this3.loading = false;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    }
  },
  created: function created() {
    this.getList();
  },
  filters: {
    level: function level(val) {
      var type = {
        1: '一级',
        2: '二级',
        3: '三级',
        4: '四级',
        5: '五级'
      };
      return type[val];
    }
  },
  computed: {
    isAuth: function isAuth() {
      return true;
    }
  }
};